import React, { useState } from "react";
import { Dialog } from "@headlessui/react";
import { ChevronLeftIcon, ChevronRightIcon, XMarkIcon } from "@heroicons/react/24/outline";

// Read-only photo gallery for a Tradesman Domestic request — a thumbnail
// strip that opens a fullscreen lightbox on click. Shared by the customer
// Show page and the tradesman (web + would-be-mobile) request detail pages.
const ImageGallery = ({ images }) => {
  const [openIndex, setOpenIndex] = useState(null);

  if (!images || images.length === 0) return null;

  const close = () => setOpenIndex(null);
  const prev = (e) => {
    e.stopPropagation();
    setOpenIndex((i) => (i - 1 + images.length) % images.length);
  };
  const next = (e) => {
    e.stopPropagation();
    setOpenIndex((i) => (i + 1) % images.length);
  };

  return (
    <>
      <ul className="grid grid-cols-3 gap-3 sm:grid-cols-4">
        {images.map((img, index) => (
          <li key={img.id || index}>
            <button
              type="button"
              onClick={() => setOpenIndex(index)}
              className="block aspect-square w-full overflow-hidden rounded-md border border-gray-200 bg-white shadow-sm transition hover:border-orange-400"
            >
              <img
                src={img.thumb_url || img.url}
                alt=""
                className="h-full w-full object-cover"
              />
            </button>
          </li>
        ))}
      </ul>

      <Dialog open={openIndex !== null} onClose={close} className="relative z-50">
        <div className="fixed inset-0 bg-black/90" aria-hidden="true" />
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel className="relative max-h-full max-w-4xl">
            {openIndex !== null && (
              <img
                src={images[openIndex].url}
                alt=""
                className="max-h-[85vh] w-auto rounded-md object-contain"
              />
            )}
            <button
              type="button"
              onClick={close}
              className="absolute -top-3 -right-3 flex h-9 w-9 items-center justify-center rounded-full bg-white text-gray-900 shadow-md"
              aria-label="Close"
            >
              <XMarkIcon className="h-5 w-5" />
            </button>
            {images.length > 1 && (
              <>
                <button
                  type="button"
                  onClick={prev}
                  className="absolute top-1/2 -left-4 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white text-gray-900 shadow-md sm:-left-14"
                  aria-label="Previous photo"
                >
                  <ChevronLeftIcon className="h-5 w-5" />
                </button>
                <button
                  type="button"
                  onClick={next}
                  className="absolute top-1/2 -right-4 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white text-gray-900 shadow-md sm:-right-14"
                  aria-label="Next photo"
                >
                  <ChevronRightIcon className="h-5 w-5" />
                </button>
              </>
            )}
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  );
};

export default ImageGallery;
